import React from 'react';
import { Container, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Layout } from 'features/common/components/Layout';
import { BranchOfficeList } from '../../features/branchOffices/components/BranchOfficeList';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { isAdminOrSuperAdmin } from '../../features/auth/helpers';
import { PageNotAllowedForUser } from '../../features/common/components/PageNotAllowedForUser';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
	},
	headerTitle: {
		marginTop: theme.spacing(3),
		textAlign: 'center',
		color: theme.palette.primary.main,
		fontWeight: 'bold',
	},
}));

function BranchOfficeListPage(): JSX.Element {
	const classes = useStyles();
	const { auth } = useSelector((state: RootState) => state);

	return (
		<Layout>
			<Container component="main" maxWidth="xl">
				{isAdminOrSuperAdmin(auth.user) ? (
					<>
						<Typography variant="h5" className={classes.headerTitle}>
							Sucursales y Métodos de Pago
						</Typography>
						<div className={classes.paper}>
							<BranchOfficeList />
						</div>
					</>
				) : (
					<PageNotAllowedForUser />
				)}
			</Container>
		</Layout>
	);
}

export default BranchOfficeListPage;
